import { render } from "./PledgeMaking.vue?vue&type=template&id=8b09fdba&scoped=true"
import script from "./PledgeMaking.vue?vue&type=script&lang=js"
export * from "./PledgeMaking.vue?vue&type=script&lang=js"

import "./PledgeMaking.vue?vue&type=style&index=0&id=8b09fdba&scoped=true&lang=css"

import exportComponent from "/vercel/path0/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8b09fdba"]])

export default __exports__